import React, { FC, useCallback, useEffect, useMemo } from 'react'
import styles from './OrderLogList.module.scss'
import { IOrderItemLog, IOrderLog } from '../../../modules/orderLog/domain/dtos/IOrderLog'
import { Button, CircularProgress, Icon, IconButton } from '@mui/material'
import { toast } from 'react-toastify'
import UseSocketPrinter from '../../../modules/printer/presentation/hooks/UseSocketPrinter'
import InvoicePrinterLayout from '../../../modules/printer/presentation/layoutPrinter/invoice/InvoicePrinterLayout'
import { IInvoice } from '../../../modules/invoice/application/dtos/IInvoiceData'
import UseDeviceStore from '../../../modules/device/store/DeviceStore'
import { useI18n } from '../../../hooks/useI18n';
import { moneyMaskNumber } from '../../../services/utils/Money'
export interface IOrderLogListProps {
    //propertys
    orders: IOrderLog[],
    emitInvoice?: (order: IOrderLog) => Promise<IInvoice[]>
    printInvoice?: (order: IOrderLog) => Promise<void>
    printOrder?: (order: IOrderLog) => void
    disabledPrinter?: boolean
    disabledEmitInvoice?: boolean
}
const OrderLogList: FC<IOrderLogListProps> = ({ orders, emitInvoice, printInvoice, printOrder, disabledPrinter, disabledEmitInvoice }) => {
    const { t } = useI18n();
    return (
        <div id={styles.OrderLogList} >
            {
                orders.map((order) => <OrderLogItem key={order.id} order={order} emitInvoice={emitInvoice} printInvoice={printInvoice} disabledPrinter={disabledPrinter}
                    disabledEmitInvoice={disabledEmitInvoice} />)
            }
        </div>
    )
}

export default OrderLogList

export interface IOrderLogItemProps {
    order: IOrderLog,
    emitInvoice?: (order: IOrderLog) => Promise<IInvoice[]>
    printInvoice?: (order: IOrderLog) => Promise<void>
    printOrder?: (order: IOrderLog) => void
    disabledPrinter?: boolean
    disabledEmitInvoice?: boolean
}
const OrderLogItem: FC<IOrderLogItemProps> = ({ order, emitInvoice, printInvoice, printOrder, disabledEmitInvoice, disabledPrinter }) => {
    const { t } = useI18n();

    const [deviceConfig] = UseDeviceStore((state) => [state.deviceConfig]);

    const [showItems, setShowItems] = React.useState(false)
    const [isLoading, setIsLoading] = React.useState(false)
    const [invoiceImage, setInvoiceImage] = React.useState<string | null>(null)

    const [html, setHtml] = React.useState<string>('')
    const { getElementHtml } = UseSocketPrinter();
    const [emitedInvoice, setEmitedInvoice] = React.useState(!!order.invoice);

    useEffect(() => {
        if(order.invoice?.every(invoice => invoice.sefaz.code)){
            setEmitedInvoice(true)
        }
    }, [order.invoice]);


    const onClickEmiteInvoice = async () => {
        if (emitInvoice) {

            try {
                setIsLoading(true)
                await emitInvoice(order)
                setIsLoading(false)
                setEmitedInvoice(true)
                toast.success(t('orderFeedback.invoiceEmittedSuccessfully'));
            } catch (error: any) {
                console.log(error)
                if (error.message) {
                    return toast.error(error.message);
                }
                toast.error(t('orderFeedback.errorEmittingInvoice'));
            } finally {
                setIsLoading(false)
            }
        }
    }
    const onClickPrintInvoice = useCallback(async () => {
        if (printInvoice) {
            try {
                setIsLoading(true);
                await printInvoice(order)
            }
            finally {
                setIsLoading(false)
            }
        }
    }, [printInvoice, order])



    useEffect(() => {
        const generateImage = async () => {
            if (order.invoice) {
                const image = await getElementHtml(<InvoicePrinterLayout invoice={order.invoice[0]} />)
                setHtml(image)
            }
        }
        generateImage();
    }, [getElementHtml, order.invoice])

    // const onload = useCallback(() => {
    //     const generateImage = async () => {
    //         if (order.invoice) {
    //             const image = await htmlToBase64(<InvoicePrinterLayout invoice={order.invoice[0]} />)
    //             setInvoiceImage(image)
    //         }
    //     }
    //     generateImage();
    // }, [htmlToBase64, order.invoice])

    return (
        <div key={order.id} className={styles.order} >
            {isLoading &&
                <div className={styles.loading} >
                    <CircularProgress size={18} />
                </div>
            }
            <div className={styles.status}>
                {/* {order.invoice ?
                    <IconButton className={styles.invoiceEmited} onClick={onClickPrintInvoice}  ><Icon>receipt_long</Icon></IconButton>
                    :
                    <IconButton className={styles.invoiceNotEmited} onClick={onClickEmiteInvoice} ><Icon>receipt_long</Icon></IconButton>
                } */}
            </div>
            <div className={styles.orderHeader} >
                <div className={styles.orderDate} ><label>{t('orderHistory.createdAt')}</label> <span>{new Date(order.createdAt + "Z").toLocaleString()}</span></div>
                <div className={styles.orderOperator} ><label>{t('orderHistory.operator')}</label> <span>{order.operator.name}</span></div>
                <div className={styles.orderId} ><label>{t('orderHistory.id')}</label> <span>#{order.id}</span></div>
                <div  ><label>Status: </label ><span className={styles.orderStatus}>{order.invoice?.length ? order.invoice?.map(invoice => invoice.status).join(', ') :  order.invoiceStatus}</span></div>
            </div>
            {<div className={styles.orderItems} >
                <div>
                    <label>{t('orderHistory.items')} ({order.orderItems?.length})</label>
                    {showItems ? <IconButton size='small' onClick={() => setShowItems(false)}><Icon fontSize='small'>expand_less</Icon></IconButton> : <IconButton size='small' onClick={() => setShowItems(true)}><Icon fontSize='small'>expand_more</Icon></IconButton>}
                </div>
                {
                    showItems && order.orderItems.map((orderItem) => <OrderItem key={orderItem.id} orderItem={orderItem} />)
                }
            </div>}
            {
                invoiceImage &&
                <img src={"" + invoiceImage} alt={t('orderHistory.orderImage')} />
            }
            <div className={styles.actions}>

                {/* <Button onClick={onload} >Exibir nota</Button> */}

                {deviceConfig?.invoice.emitEnabled && (emitedInvoice
                    ? deviceConfig.printer?.receiptPrinterSectorId ? <Button disabled={isLoading || disabledPrinter} className={styles.invoiceEmited} onClick={onClickPrintInvoice} ><Icon>receipt_long</Icon> {t('orderHistory.printInvoice')}</Button> : null
                    : <Button disabled={isLoading || disabledEmitInvoice} className={styles.invoiceNotEmited} onClick={onClickEmiteInvoice} ><Icon>receipt_long</Icon> {t('orderHistory.emitInvoice')}</Button>
                )}
            </div>
            {/* {
                order.invoice &&
                <div className={styles.invoice} >
                    <InvoicePrinterLayout invoice={order.invoice[0]} />
                </div>
            }
            {
                html && <div dangerouslySetInnerHTML={{
                    __html: html
                }} ></div>
            }
            {html} */}
        </div >
    )
}

const OrderItem: FC<{ orderItem: IOrderItemLog }> = ({ orderItem }) => {
    return (
        <div key={orderItem.id} className={styles.orderItem} >

            <div className={styles.productName} >
                <span className={styles.quantity}>{orderItem.quantity} - </span>
                <span className={styles.productName} >{orderItem.name}</span>
            </div>
            <div className={styles.price} >{moneyMaskNumber(orderItem.price)}</div>

            {/* <div className={styles.actions}>
                <IconButton><Icon>print</Icon></IconButton>
            </div> */}
        </div>
    )
}